import { render, staticRenderFns } from "./DocProtocol.vue?vue&type=template&id=6a40cb4f&scoped=true"
import script from "./DocProtocol.vue?vue&type=script&lang=js"
export * from "./DocProtocol.vue?vue&type=script&lang=js"
import style0 from "./DocProtocol.vue?vue&type=style&index=0&id=6a40cb4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a40cb4f",
  null
  
)

export default component.exports